import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../utils/config';

export default function AddOrderItems() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [items, setItems] = useState([
    { product_id: '', quantity: 1, price: '' }
  ]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/products`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => setProducts(res.data));
  }, [token]);

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const addRow = () => {
    setItems([...items, { product_id: '', quantity: 1, price: '' }]);
  };

  const removeRow = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await axios.post(`${API_BASE_URL}/api/orders/${orderId}/items`, { items }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    navigate('/orders');
  };

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Add Order Items</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {items.map((item, index) => (
          <div key={index} className="grid grid-cols-4 gap-2">
            <select
              name="product_id"
              value={item.product_id}
              onChange={(e) => handleItemChange(index, 'product_id', e.target.value)}
              required
              className="border px-3 py-2 rounded"
            >
              <option value="">Select Product</option>
              {products.map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
            <input
              type="number"
              min="1"
              name="quantity"
              value={item.quantity}
              onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
              className="border px-3 py-2 rounded"
              required
            />
            <input
              type="number"
              min="0"
              step="0.01"
              name="price"
              value={item.price}
              onChange={(e) => handleItemChange(index, 'price', e.target.value)}
              className="border px-3 py-2 rounded"
              required
            />
            <button type="button" onClick={() => removeRow(index)} className="bg-red-600 text-white px-2 rounded">Remove</button>
          </div>
        ))}
        <button type="button" onClick={addRow} className="bg-gray-600 text-white px-4 py-2 rounded">Add Row</button>
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Save Items</button>
      </form>
    </div>
  );
}